import styled from 'styled-components';

export const CompanyBenchmarkingWrapper = styled.div``;
